import React from "react";

export default function ClientBlock({
  title = "Client",
  clientName,
  address,
  phone,
  email,
}) {
  return (
    <div
      style={{
        border: "1px solid #dbe7f3",
        borderRadius: 14,
        padding: 16,
        marginBottom: 18,
        background: "#fbfdff",
      }}
    >
      <div
        style={{
          fontSize: 12,
          color: "#b08900",
          marginBottom: 10,
          textTransform: "uppercase",
          letterSpacing: 0.5,
          fontWeight: 700,
        }}
      >
        {title}
      </div>

      <div
        style={{
          fontSize: 20,
          fontWeight: 800,
          marginBottom: 6,
          color: "#0c2740",
        }}
      >
        {clientName || "Client"}
      </div>

      {address && (
        <div
          style={{
            color: "#5b6b7c",
            whiteSpace: "pre-wrap",
            lineHeight: 1.5,
            marginBottom: 10,
          }}
        >
          {address}
        </div>
      )}

      {phone && (
        <div style={{ marginBottom: 4 }}>
          <b>Phone:</b> {phone}
        </div>
      )}

      {email && (
        <div>
          <b>Email:</b> {email}
        </div>
      )}
    </div>
  );
}
